import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Links } from "../../../../assets/icons/links.svg";
import { getCountryByCode } from "../../../../utils/Helper.js";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowRight2.svg";
import { FRONTEND_URL } from "../../../../constants/apiUrls.js";
import { capitalize } from "../../../../global_functions/global.js";
import img from "../../../../assets/images/companylogo.png";
import { ReactComponent as OrderInProgress } from "../../../../assets/icons/orderInProgress.svg";
import { ReactComponent as Verified } from "../../../../assets/icons/verified.svg";
import { ReactComponent as Claimed } from "../../../../assets/icons/claimed.svg";
import CommonTooltip from "../../../common/Tooltip.jsx";

const EnterpriseRequestTable = ({ enterpriseData, page, setPage, selectedEnterprise }) => {
    const navigate = useNavigate();
    const [companyListed, setCompanyListed] = useState([]);

    useEffect(() => {
        if (enterpriseData?.results?.length >= 0) {
            const dataArray = enterpriseData?.results?.map(item => ({
                companyName: item,
                address: item?.state && item?.state !== '-' ? capitalize(item?.state) + ", " + capitalize(getCountryByCode(item?.country)) : capitalize(getCountryByCode(item?.country)),
                recentChanges: item?.updates,
                profileCompletion: <div className="flex justify-center items-center gap-2"><div className="w-full h-[10px] border rounded-full bg-[#FEC9BE]"><div className={`h-full bg-[#FB512D] rounded-full`} style={{width:`${item.percent}%`}}></div></div><div className="w-[40px]">{item.percent}%</div></div>,
                action: (item?.company_id || item?.worldbox_id) ?? null,
                company: item
            }));
            setCompanyListed(dataArray)
        }
    }, [enterpriseData]);

    const onRowClick = (id) => {
        const url = `${FRONTEND_URL}/search/${id}`;
        window.open(url, "_blank");
    };

    return (
        <>
            <div className="bg-white rounded-xl p-4">
                <div className="text-left w-full font-semibold text-[16px] text-primary mt-2 mb-4">All of the requests by Companies & Individuals</div>
                <div className="overflow-x-auto">
                    <table className="min-w-full table-auto bg-white rounded-lg">
                        <thead className="justify-between">
                            <tr className="h-14 border-b border-grey-500">
                                <th className="px-2 py-2 text-left">
                                    <span className="text-gray-500 text-sm font-bold w-[400px]">Company Name</span>
                                </th>
                                <th className="px-2 py-2 text-left">
                                    <span className="text-gray-500 text-sm">Address</span>
                                </th>
                                <th className="px-2 py-2 text-left">
                                    <span className="text-gray-500 text-sm">Recent Changes</span>
                                </th>
                                <th className="px-2 py-2 text-left">
                                    <span className="text-gray-500 text-sm">Profile Completion </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-gray-200">
                            {companyListed.map((companyListed, index) => (
                                <tr key={index} className="bg-white h-16 hover:bg-transparent">
                                    <td className="px-2 py-2 text-left ">
                                        <div className="flex justify-between items-center w-[400px]">
                                            <div className="flex gap-2 items-center w-[370px]">
                                            <img src={companyListed?.companyName?.logo ?? img} className="w-[40px] h-[40px] rounded-full" alt="Company Creation"></img>
                                            <p onClick={(companyListed.companyName.company_id || companyListed.companyName.worldbox_id) ? () => onRowClick(companyListed.companyName.company_id || companyListed.companyName.worldbox_id) : null} className={`text-gray-600 flex items-center justify-start flex-wrap gap-2 ${(companyListed.companyName.company_id || companyListed.companyName.worldbox_id) ? "cursor-pointer" : "cursor-not-allowed"}`}>{companyListed.companyName.company_name}</p>
                                            </div>
                                            <div className="w-[20px]">
                                                <CommonTooltip id={"progress-report"} content={companyListed?.companyName?.status === 'WORLDBOX_ORDER_CREATED' ? "In Progress" : companyListed?.companyName?.verified ? "Verified" : companyListed?.companyName?.claimed ?"Claimed" : null}>
                                                {companyListed?.companyName?.status === 'WORLDBOX_ORDER_CREATED' ? <OrderInProgress/> : companyListed?.companyName?.verified ? <Verified/> : companyListed?.companyName?.claimed ? <Claimed/> : null}
                                                </CommonTooltip>
                                            </div>
                                        </div>

                                    </td>
                                    <td className="px-2 py-2 text-left">
                                        <span className="text-gray-600">{companyListed.address}</span>
                                    </td>
                                    <td className="px-2 py-2 text-left">
                                        <span onClick={companyListed.recentChanges?.length > 0 ? () => { navigate("/dashboard/enterprise/act-log", { state: { company: companyListed?.company, page, enterpriseID: selectedEnterprise?.id }, }) } : null} className={`text-gray-600 ${companyListed.recentChanges?.length > 0 ? "cursor-pointer font-bold" : "cursor-not-allowed"}`}>{companyListed.recentChanges?.length > 0 ? `${companyListed.recentChanges?.length} New Updates` : "No New Updates"}</span>
                                    </td>
                                    <td className="px-2 py-2 text-left">
                                        <span className="text-gray-600">{companyListed.profileCompletion}</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div >
            {enterpriseData?.total_pages > 1 && <div className="flex justify-center items-center mt-3">
                <div className="flex gap-2 items-center text-f16">
                    <div
                        className={`flex text-[#002940] gap-1 ${page === 1 ? "cursor-not-allowed" : "cursor-pointer"
                            }`}
                        onClick={page > 1 ? () => setPage(page - 1) : null}
                    >
                        <ArrowRight className="rotate-180 mt-[1px]" /> Previous
                    </div>
                    <div>
                        Page {page} of {enterpriseData?.total_pages}
                    </div>
                    <div
                        className={`flex text-[#002940] gap-1 ${page === enterpriseData?.total_pages
                            ? "cursor-not-allowed"
                            : "cursor-pointer"
                            }`}
                        onClick={
                            page < enterpriseData?.total_pages
                                ? () => setPage(page + 1)
                                : null
                        }
                    >
                        Next <ArrowRight className="mt-[1px]" />
                    </div>
                </div>
            </div>
            }
        </>
    );
};

export default EnterpriseRequestTable;
